import { Form, Radio } from "antd";
import AlertInfo from "components/alert-info";
import Context from "context/appContext";
import React, { useContext, useEffect, useState } from "react";
import { getUrl } from "utils/utils";

import EcoColision from "../../../assets/images/eco-colision.png";
import Eco from "../../../assets/images/ecologico.png";

// @styles
import "./styles.scss";

export default function RadioGroup({ info, key, form, current }) {
  const [values, setValues] = useState([]);
  const [message, setMessage] = useState([]);
  const [image, setImage] = useState("");
  const {
    customRequest,
    dataForm: { formResponses },
    model,
    formStatus: {
      steps,
      currentStep,
      currentQuestion,
      numberQuestionsStep,
      isGoToBack,
    },
    setFormStatus,
  } = useContext(Context);

  useEffect(() => {
    getValues();
  }, [model]);

  const getValues = async () => {
    if (info.content && model) {
      const index = formResponses.findIndex((x) => x.key === info.key);
      let value = index != -1 ? formResponses[index].value : "";
      value = value ? value : info.defaultValue;
      const dataLcl = info.content;
      const opciones_servicio = getUrl(dataLcl, formResponses);
      setValues([{ label: "Cargando...", value: "Cargando", disabled: true }]);
      const response = await customRequest(
        opciones_servicio.url,
        opciones_servicio.headers,
        opciones_servicio.method,
        opciones_servicio.body
      );

      const valuesResponse =
        response && response.length
          ? response
          : response && response.data && response.data.length
            ? response.data
            : [];

      info.valuesResponse = valuesResponse;

      index !== -1
        ? (formResponses[index].valuesResponse = valuesResponse)
        : formResponses.push(info);

      setValues(response && !response.message ? valuesResponse : []);

      if (isGoToBack) {
        form.setFieldsValue({ [info.key]: value.key });
        setFormStatus({
          steps,
          currentStep,
          currentQuestion,
          numberQuestionsStep,
          isGoToBack: false,
        });
        onChange({ target: { value: value.key } });
      } else {
        form.setFieldsValue({ [info.key]: [] });
        setMessage([]);
      }
    }
  };

  const validateProperties = (properties) => {
    let propertie = "";
    if (properties.collisionWarning) {
      propertie = "CW";
    }
    if (properties.ecoFriendly) {
      propertie = propertie + "EF";
    }
    const img = `${propertie}Image`;
    return { propertie, img };
  };

  const getMessage = (properties) => {
    const iteratorMessage = properties.split("|");
    let arrayMessage = [];
    iteratorMessage.forEach((e) => {
      let ol = e.split("!");
      ol[0] = ol[0] + "!";
      arrayMessage.push({
        title: ol[0],
        description: ol[1],
      });
    });
    setMessage(arrayMessage);
  };

  const onChange = ({ target }) => {
    info.value = target.value;
    const index = formResponses.findIndex((x) => x.key === info.key);
    const object = formResponses[index].valuesResponse.find(
      (x) => x.key === target.value
    );
    index != -1
      ? (formResponses[index].value = {
        key: object.key,
        description: object.description,
        cw: object.properties.collisionWarning,
      })
      : formResponses.push({
        key: object.key,
        description: object.description,
        cw: object.properties.collisionWarning,
      });
    if (object && object.properties) {
      let { propertie, img } = validateProperties(object.properties);
      if (propertie) {
        propertie = info.properties[propertie];
        const altText=img?.replace('Image','alt')
        setImage({url:info.properties[img],alt:info.properties[altText]});
        getMessage(propertie);
      } else {
        setMessage([]);
      }
    }
  };

  return (
    <div className="radio-custom">
      <Form.Item
        className="ant-form-item-normal"
        name={info.key}
        key={key}
        rules={[
          {
            required: model ? true : false,
            message: "Campo obligatorio",
          },
        ]}
      >
        <Radio.Group className="" onChange={onChange}>
          {values.length &&
            values.map((val, index) => (
              <Radio
                key={index}
                name={val.key}
                value={val.key}
                data-testid={`radio-group-${index}`}
              >
                {val.description}
              </Radio>
            ))}
        </Radio.Group>
      </Form.Item>
      {message && message.length ? (
        <AlertInfo message={message} img={image} />
      ) : null}
    </div>
  );
}
